import { render, staticRenderFns } from "./tdStatistics.vue?vue&type=template&id=1c308643&scoped=true"
import script from "./tdStatistics.vue?vue&type=script&lang=js"
export * from "./tdStatistics.vue?vue&type=script&lang=js"
import style0 from "./tdStatistics.vue?vue&type=style&index=0&id=1c308643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c308643",
  null
  
)

export default component.exports